import CbRadio from './src/radio.vue';

CbRadio.install = function(Vue) {
  Vue.component(CbRadio.name, CbRadio);
};

export default CbRadio;
